import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import userApi from '../../api/userApi';

const RelatedProductSection = () => {
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const products = await userApi.getProduct();
                // Map qua tất cả các productDetails từ response
                const allProductDetails = products.flatMap((product) => product.productDetails);
                setRelatedProducts(allProductDetails);
            } catch (error) {
                console.error('Failed to fetch related products:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const handleAddToCart = (productId) => {
        console.log(`Added product ${productId} to cart`);
        // Logic thêm sản phẩm vào giỏ hàng
    };

    if (loading) {
        return <div>Loading related products...</div>;
    }

    if (relatedProducts.length === 0) {
        return <div>No related products available.</div>;
    }

    return (
        <section className="related-product-section">
            <div className="container">
                <h2 className="related-product__title">Related Products</h2>
                <div className="row gy-sm-4 g-3">
                    {relatedProducts.slice(0, 4).map((item) => (
                        <div className="col-lg-3 col-md-4 col-6 col-xxs-12" key={item.productDetailId}>
                            <div className="fz-1-single-product">
                                <div className="fz-single-product__img">
                                    <img src={item.imageLink} alt={item.name} />
                                    <div className="fz-single-product__actions">
                                        <button
                                            className="fz-add-to-cart-btn"
                                            onClick={() => handleAddToCart(item.productDetailId)}
                                        >
                                            <span className="btn-txt">Add to cart</span>
                                            <span className="btn-icon">
                                                <i className="fa-light fa-cart-shopping"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div className="fz-single-product__txt">
                                    <a href={`${item.url}`} className="fz-single-product__title" target="_blank" rel="noopener noreferrer">
                                        {item.name}
                                    </a>

                                    <div className="fz-single-product__price-rating">
                                        <p className="fz-single-product__price">
                                            <span className="current-price">
                                                ${item.price.toLocaleString('en-US')}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default RelatedProductSection;
